import { AreaType } from '../SetFloorsModal/FloorItem';

// eslint-disable-next-line no-shadow, no-unused-vars
export enum MapOccupancyWidgetType { COUNT, UTILISATION, BOOKINGS, QUEUE, GRAPH, TRAFFIC }

const mapOccupancyConfig = {
  area: {
    [AreaType.GYM]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.BOOKINGS,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
      ],
    },
    [AreaType.IT_HELPDESK]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.QUEUE,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
      ],
    },
    [AreaType.RECEPTION]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.QUEUE,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
      ],
    },
    [AreaType.MEETING_AREA]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.BOOKINGS,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
      ],
    },
    [AreaType.CAFE]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.QUEUE,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
      ],
    },
    [AreaType.TOILET]: {
      live: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.UTILISATION,
      ],
      historic: [
        MapOccupancyWidgetType.COUNT,
        MapOccupancyWidgetType.GRAPH,
        MapOccupancyWidgetType.UTILISATION,
        MapOccupancyWidgetType.TRAFFIC,
      ],
    },
  },
};

export const defaultMapOccupancyConfig: MapOccupancyWidgetType[] = [
  MapOccupancyWidgetType.COUNT,
  MapOccupancyWidgetType.GRAPH,
];

export default mapOccupancyConfig;
